module.exports = __webpack_public_path__ + "fonts/Inter-500-vietnamese36.74fe938.woff2";